import { TargetComponents } from '../../../types';

export const getTargetComponentsIDList = (
  targetComponents: TargetComponents,
): string => {
  return [
    targetComponents.leadingGroupInfo.groupId,
    ...targetComponents.subsetGroupInfos.map((info) => info.groupId),
  ].join('\n');
};
